export const blueMui = {
  /**
   * Preview: ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png)
   */
  _50: "#e3f2fd",
  /**
   * Preview: ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png)
   */
  _100: "#bbdefb",
  /**
   * Preview: ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png)
   */
  _200: "#90caf9",
  /**
   * Preview: ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png)
   */
  _300: "#64b5f6",
  /**
   * Preview: ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png)
   */
  _400: "#42a5f5",
  /**
   * Preview: ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png)
   */
  _500: "#2196f3",
  /**
   * Preview: ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png)
   */
  _600: "#1e88e5",
  /**
   * Preview: ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png)
   */
  _700: "#1976d2",
  /**
   * Preview: ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png)
   */
  _800: "#1565c0",
  /**
   * Preview: ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png)
   */
  _900: "#0d47a1",
  /**
   * Preview: ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png)
   */
  A100: "#82b1ff",
  /**
   * Preview: ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png)
   */
  A200: "#448aff",
  /**
   * Preview: ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png)
   */
  A400: "#2979ff",
  /**
   * Preview: ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
   */
  A700: "#2962ff",
};
